import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Form.css';
import logo from '../../../assets/images/Logo.svg';
import check from '../../../assets/images/check.svg';

function JobPostSuccess() {
	let navigate = useNavigate();

	const handlePath = e => {
		e.preventDefault();
		navigate(`/`);
	};

	return (
		<div className='main-container form-bg-color form-bg-log'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<img
					src={check}
					style={{
						height: '7vmin',
						pointerEvents: 'none',
						marginBottom: '7px',
					}}
					alt='logo'
				/>
				<div className='form-label2-vmn'>Job Posted Successfully</div>
				<button type='submit' onClick={handlePath} className='btn-send-code'>
					GO BACK TO DASHBOARD
				</button>
			</div>
		</div>
	);
}

export default JobPostSuccess;
